import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EnumUserRol } from 'src/app/models/shared/app-enums';
import { Company } from 'src/app/models/shared/company';
import { AuthService } from 'src/app/Service/auth.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { EventService } from 'src/app/Service/event.service';
import { Constants } from 'src/assets/Constats';
import { SharedConstants } from 'src/app/models/shared/shared.constants';
import Swal from 'sweetalert2';
import { PaginationTableService } from '../../shared/pagination/pagination-table/pagination-table.service';

@Component({
  selector: 'app-list-company',
  templateUrl: './list-company.component.html'
})

export class ListCompanyComponent implements OnInit, OnDestroy {

  waitFor = false;
  dataInformation = <any>[];
  emptyDataList: boolean = true;
  msgDataEmpty: string = "El criterio de búsqueda ingresado no existe.";
  IsPostBack = false;
  rotate = true;

  resetTable = false;
  entity: Company = {}
  idEntity: string = "0";
  //Alta
  fmDetail: FormGroup;
  modalRef: BsModalRef;
  modalConfig = {
    backdrop: true,
    ignoreBackdropClick: false,
    keyboard: false,
    class: '',
  };

  msg_confirmDelete: string;
  btnYes: string;
  btnCancel: string;
  msgProcessedSuccessfully: string = "The registration has been processed successfully.";

  private userData: any;
  currentUser: any;

  /** For filter */
  private componentForm: FormGroup;
  private readonly regexPattern: string;

  /** Variables of pagination */
  protected totalPages: any[] = [];
  protected currentPage: number = 1;

  constructor(
    private readonly sharedConstants: SharedConstants,
    private readonly fb: FormBuilder,
    private readonly _errorS: ErrorCustomService,
    private readonly _modalService: NgbModal,
    _config: NgbModalConfig,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    protected eventService: EventService,
    private readonly paginationTableService: PaginationTableService,
    private readonly _service: CompanyService) {
    //Configuración para modal global
    _config.backdrop = 'static';
    _config.keyboard = false;
    //Validar rol de usuario 
    this.userData = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.userData);

    this.authService.currentUser.subscribe(resp => {
      //console.log(resp);
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      if (this.currentUser.roles[0].id != EnumUserRol.SUPER_ADMIN) {
        this.authService.logout();
      }
    });

    this.regexPattern = this.sharedConstants.regexPattern.alphanumeric;

    this.componentForm = this.fb.group({
      ddlUser: [''],
      ddlStatus: [''],
      //txtName: ['', [Validators.maxLength(50), Validators.pattern(this.regexPattern)]],
    });
  }

  get f() { return this.componentForm.controls; }

  ngOnInit(): void {
    try {
      this.getDataLanguage();
      this.loadData();
    } catch (error) {
      console.log('Error: ' + error);
    }
  }

  /** For when the page is closed */
  public ngOnDestroy(): void {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('searchField');
  }

  /** Set values of form */
  protected setValuesForm(): void {
    this.componentForm.patchValue({
      txtName: localStorage.getItem('searchField') ?? '',
    });
  }

  getDataLanguage() {
    this.translate.stream('common.lblConfirmDelete').subscribe((res: string) => {
      this.msg_confirmDelete = res;
    });

    this.translate.stream('common.yes').subscribe((res: string) => {
      this.btnYes = res;
    });

    this.translate.stream('common.btnCancel').subscribe((res: string) => {
      this.btnCancel = res;
    });

    this.translate.stream('common.msgEmptyGrid').subscribe((res: string) => {
      this.msgDataEmpty = res;
    });


    this.translate.stream('common.msgProcessedSuccessfully').subscribe((res: string) => {
      this.msgProcessedSuccessfully = res;
    });
  }

  /** Validating value of filters */
  validateFilters() {
    let _name = (this.componentForm.get('txtName')?.value) ? this.componentForm.get('txtName').value : null;

    console.log(_name);

    return _name;
  }

  /** When user select clean filter, reload page */
  protected removeFilter() {
    localStorage.removeItem('searchField');
    window.location.reload();
  }

  /** PENDING */
  protected searchInfo() {
    this.currentPage = this.paginationTableService.resetPageCurrent();
    this.loadData();
  }

  loadData() {

    this.waitFor = true;
    this.eventService.startLoadingData();

    let _parametros = this.getParameters();

    this._service.GetCompanyList(_parametros, this.currentPage).subscribe({
      next: res => {
        let _result = res;
        this.dataInformation = res.body.content;
        console.log("GetCompanyList=> ", res);

        if (res.ok) {
          this.waitFor = false;
          this.totalPages = res.body.totalPages;
          this.resetTable = false;
          localStorage.setItem('isInitLoad', '0');

          this.emptyDataList = _result.body.empty;
          this.IsPostBack = true;
          console.log(this.dataInformation);
        }
        else {
          this.translate.stream('common.error500').subscribe((res: string) => {
            this.eventService.errorMessage(0, res);
          });
        }
        this.eventService.completeLoadingData();
        this.waitFor = false;
      },
      error: error => {
        console.log(error);
        this._errorS.onValidateErrorCode(error);
        this.eventService.completeLoadingData();
        this.waitFor = false;
      }
    });

  }

  /** Get value of parameters */
  getParameters(): string {
    let _result = "";

    /*let Name = this.componentForm.get('txtName')?.value;

    localStorage.setItem('searchField', Name);*/

    let _parametros = [
      'userId=' + localStorage.getItem("userId"),
      //'description=' + Name,
    ].join('&');

    console.log("_parametros=>", _parametros);
    _result = _parametros;

    return _result;
  }

  onOpen(content: any) {
    this._modalService.open(content, { size: 'xl' });
  }

  onEditItem(id: string, content: any) {
    this.idEntity = id.toString();

    this._modalService.open(content, { size: 'xl' });
  }

  public async onSync(idCompany: any) {
    //alert("Sincronizar empresa: " + idCompany);
    try {
      this.eventService.startLoadingData();
      const response: any = await this._service.syncCompany(idCompany, this.currentUser.id);
      if (response && response.code == 'SUCCESS') {
        this.eventService.successMessage(2, 'companies.sync.success');
        this.loadData();
      } else {
        this.eventService.errorMessage(3, 'companies.sync.error');
      }
    } catch (error) {
      this.eventService.errorMessage(3, 'companies.sync.error');
    } finally {
      this.eventService.completeLoadingData();
    }

  }

  onViewItem(id: string, content: any) {
    this.idEntity = id.toString();
    this._modalService.open(content, { size: 'xl' });
  }

  onDelete(id: string, name: string): void {
    Swal.fire({
      text: this.msg_confirmDelete + name + "?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.btnYes,
      denyButtonText: "No",
      cancelButtonText: this.btnCancel,
      confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
      cancelButtonColor: Constants.SWEET_ALERT_PROPERTIES.cancelButtonColor,
    }).then((result) => {
      if (result.value) {
        this.eventService.startLoadingData();
        this.authService.onValidateCookieUserUI();

        if (result.isConfirmed) {
          this.entity.id = id;
          this._service.DeleteCompanyDetail(this.entity).subscribe({
            next: res => {
              console.log(res);
              this.eventService.completeLoadingData();
              let _result = res;
              console.log(_result);
              if (_result.ok) {
                this.eventService.successMessage(3, this.msgProcessedSuccessfully);
              }

              //recargar pantalla
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            },
            error: error => {
              console.log(error);
              this.eventService.completeLoadingData();
              let msg = "Ocurrió un error al procesar su solicitud.";
              if (error.error) {
                msg = error.error;
              }
              this.eventService.errorMessage(0, msg);
            }
          });
        }
        else if (result.isDenied) {
          Swal.close();
        }

      }
    });
  }

  protected changePage($event: any): void {
    this.currentPage = $event;
    this.ngOnInit();
  }

}
